const BREAKPOINT_VALUES = {
  phone: null,
  tablet: 768,
  desktop: 1024,
  large_desktop: 1200
};
const mediaQueries = [null, `@media (min-width: ${BREAKPOINT_VALUES.tablet}px)`, `@media (min-width: ${BREAKPOINT_VALUES.desktop}px)`, `@media (min-width: ${BREAKPOINT_VALUES.large_desktop}px)`];
const breakpointKeys = ['sm', 'md', 'lg', 'xl'];
const media = {
  md: mediaQueries[1],
  // min-width tablet
  lg: mediaQueries[2],
  // min-width desktop
  xl: mediaQueries[3] // min-width large desktop
};
export { BREAKPOINT_VALUES, breakpointKeys, media, mediaQueries };
//# sourceMappingURL=breakpoints.js.map
